import { slices } from "@/constants/sliceNames";
import { requestResourcesStatus } from "@/store/effects/admin-dashboard/resources-effects";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  resources: [],
  loading: false,
  error: null,
};

const resourcesSlice = createSlice({
  name: slices.resources,
  initialState,
  extraReducers: {
    ...requestResourcesStatus,
  },
});

const { actions, reducer } = resourcesSlice;

export { actions, initialState };

export default reducer;
